import React, { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { openApi } from "../../services/api";

const VerifyEmail = () => {
  const [state, setState] = useState("loading");

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token") || "";
    if (!token) {
      setState("invalid");
      return undefined;
    }
    let active = true;
    openApi.post("/auth/verify-email", { token })
      .then(() => { if (active) setState("ok"); })
      .catch(() => { if (active) setState("invalid"); });
    return () => { active = false; };
  }, []);

  const title = state === "ok"
    ? "Correo confirmado"
    : state === "loading"
      ? "Confirmando tu correo…"
      : "Este enlace ya no sirve";
  const body = state === "ok"
    ? "Ya puedes iniciar sesión. En el primer acceso te pediremos confirmar el WhatsApp de la cuenta."
    : state === "loading"
      ? "Espera un momento."
      : "Pide un enlace nuevo desde el inicio de sesión, con el mismo correo del registro.";

  return (
    <main style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#f7f9ff", padding: 24, fontFamily: "Inter, sans-serif" }}>
      <section style={{ maxWidth: 460, background: "#fff", borderRadius: 18, padding: 28, boxShadow: "0 18px 60px rgba(15,23,42,0.10)" }}>
        <h1 style={{ marginTop: 0 }}>{title}</h1>
        <p style={{ color: "#475569", lineHeight: 1.5 }}>{body}</p>
        <RouterLink to="/login" style={{ color: "#2563eb", fontWeight: 700 }}>Ir a iniciar sesión</RouterLink>
      </section>
    </main>
  );
};

export default VerifyEmail;
